import PhoneValidation from './PhoneValidation';

export default PhoneValidation;
